module.exports = __webpack_public_path__ + "static/media/sky-sports-logo.8a0e7662.png";